<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Traslado de acopio a planta</h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              nextButtonText="Siguiente"
              backButtonText="Atrás"
              finishButtonText="Finalizar"
              @on-complete="handleFinish"
              title=""
              subtitle=""
            >
              <tab-content title="Ingrese datos de la guia de despacho" :before-change="checkStep1Validations">
                <step-1 ref="step1" :form="form"></step-1>
              </tab-content>
              <tab-content title="Seleccionar pallets a despachar">
                <step-2 ref="step2"></step-2>
              </tab-content>
              <template slot="finish"
                ><b-button
                  size="lg"
                  variant="primary"
                  :disabled="loading"
                  class="wizard-footer-right finish-button font-weight-bold"
                  @click.native="handleFinish"
                  style="font-family: Arial"
                  >Finalizar</b-button
                ></template
              >
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
export default {
  name: "Traslados",
  components: {
    Step1,
    Step2
  },
  data() {
    return {
      loading: true,
      form: {
        id: null,
        client: null,
        number: null,
        waybill_date: null,
        internal_note: null,
        note: null,
        license_plate: null,
        truck_driver: null
      }
    };
  },
  methods: {
    checkStep1Validations() {
      this.$refs["step1"].$v.form.$touch();
      if (this.$refs["step1"].$v.form.$anyError) {
        return false;
      } else {
        return true;
      }
    },
    handleFinish() {
      if (this.$refs["step2"].items.length <= 0) {
        this.$swal("Debe ingresar pallets a despacho", "", "warning");
        return false;
      } else {
        this.$router.push({ path: "/despacho/list" });
        this.submit();
      }
    },
    async submit() {
      const thisV = this;
      thisV.loading = true;
      const url = "/production/save-traslado/";
      var payload = thisV.form;
      payload.items = thisV.$refs["step2"].items;
      try {
        const response = await thisV.$axios.post(url, payload);
        thisV.loading = false;
        thisV.$swal("Operación realizada con éxito", "", "success");
      } catch (e) {
        console.log(e);
        thisV.loading = false;
        thisV.$swal("Ocurrió un error", "", "error");
      }
    }
  }
};
</script>

<style></style>
